/** Technical SSE framing only; preserve multiline event data. */
export function parseSseFrame(frame: string): { eventType: string; data: string } | null {
  const lines = frame.replace(/\r\n/g, "\n").split("\n");
  let eventType = "message";
  const dataLines: string[] = [];
  for (const line of lines) {
    if (!line || line.startsWith(":")) continue;
    if (line.startsWith("event:")) { eventType = line.slice("event:".length).trim(); continue; }
    if (line.startsWith("data:")) dataLines.push(line.slice("data:".length).trimStart());
  }
  return dataLines.length ? { eventType, data: dataLines.join("\n") } : null;
}
